import React from 'react';
import { useNavigate } from 'react-router-dom';

const ToolsPage = ({ onBackToOptionSelector, authData }) => {
  const navigate = useNavigate();

  const handleToolSelect = (toolKey) => {
    if (toolKey === 'queueMapping') {
      navigate('/tools/queue-mapping');
    } else if (toolKey === 'functionCreator') {
      navigate('/tools/wxcc-function-generator');
    } else if (toolKey === 'userListExport') {
      navigate('/tools/user-list-export');
    }
    // Add more tool navigation here as you add more tools
  };

  const toolsOptions = {
    queueMapping: {
      name: "Queue Mapping Function",
      description: "Map queues from an input file to Webex CX configuration."
    },
    functionCreator: {
      name: "WxCC Function Generator",
      description: "Leverages Gemini LLM and WxCC API's to help automate function creation to be used in WxCC Flows"
    },
    userListExport: {
      name: "User List Export",
      description: "Export all WxCC users to an Excel spreadsheet with detailed user information"
    }
    // Add more tool options here as needed
    /*
    anotherTool: {
      name: "Another Utility Tool",
      description: "Description of another tool."
    }
    */
  };

  return (
    <div style={{ padding: '20px', maxWidth: '900px', margin: 'auto', fontFamily: 'Inter, sans-serif', backgroundColor: '#f9f9f9', borderRadius: '8px', boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}>
      <h1 style={{ color: '#333', textAlign: 'center', marginBottom: '25px' }}>Select a Tool</h1>
      <p style={{ textAlign: 'center', color: '#555', marginBottom: '30px' }}>
        Choose a utility function to perform.
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '20px', justifyContent: 'center' }}>
        {Object.keys(toolsOptions).map((key) => {
          const tool = toolsOptions[key];
          return (
            <div
              key={key}
              style={{
                backgroundColor: '#ffffff',
                padding: '20px',
                borderRadius: '10px',
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.05)',
                textAlign: 'center',
                cursor: 'pointer',
                transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
              }}
              onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-5px)'; e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.1)'; }}
              onMouseLeave={(e) => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.05)'; }}
              onClick={() => handleToolSelect(key)}
            >
              <h3 style={{ fontSize: '1.2em', marginBottom: '10px', color: '#333' }}>{tool.name}</h3>
              <p style={{ fontSize: '0.9em', color: '#666' }}>{tool.description}</p>
              <button
                style={{
                  marginTop: '15px',
                  padding: '8px 15px',
                  backgroundColor: '#007bff',
                  color: 'white',
                  border: 'none',
                  borderRadius: '5px',
                  cursor: 'pointer',
                  fontSize: '0.9em',
                  fontWeight: '600',
                  transition: 'background-color 0.3s ease'
                }}
                onClick={(e) => { e.stopPropagation(); handleToolSelect(key); }}
              >
                Select
              </button>
            </div>
          );
        })}
      </div>

      <div style={{ textAlign: 'center', marginTop: '40px' }}>
        <button
          onClick={onBackToOptionSelector}
          style={{
            padding: '10px 20px',
            backgroundColor: '#6c757d',
            color: '#fff',
            border: 'none',
            borderRadius: '5px',
            cursor: 'pointer',
            fontSize: '0.9em',
            transition: 'background-color 0.3s ease'
          }}
        >
          Back to Main Menu
        </button>
      </div>
    </div>
  );
};

export default ToolsPage;